import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';

class MessageModal extends React.Component {

  render() {
    return (
      <Modal show={this.props.openModal} onHide={this.props.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Komunikat</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>{this.props.content}</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.closeModal}>Zamknij</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
MessageModal.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default MessageModal;



// WEBPACK FOOTER //
// src/routes/MessageDetail/MessageModal.js